import { BROADCAST_SET_ATTENDEE_PRESENCE } from 'actions/Types';

export default attendeeId => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_ATTENDEE_PRESENCE,
      payload: {
        attendeeId,
        presence: true
      }
    };

    dispatch(action);
  };
};
